import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Modal, Box, Typography, Button, Grid, TextField, Chip, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomTable from '../common/customTable';
import { useNavigate } from "react-router-dom";
import { PrestadorContext } from '../../context/prestadorContext';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import colors from '../../../config/colors';


const VerDetallesPrestadores = ({lista, verMas}) => {
    const { setIdPrestador, setNombrePrestador } = useContext(PrestadorContext);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [cantidadRegistros, setCantidadRegistros] = useState(0);
    const [data, setData] = useState([])
    const [search, setSearch] = useState('')
    const [idRegimen, setIdRegimen] = useState(0)
    const [descripcionRegimen, setDescripcionRegimen] = useState('')
  
    const columnas = [
        {
            id: 'nombre',
            label: 'Nombre',
            minWidth: 170
        }
    ]
    
    const acciones = [
        { 
            icono: <Button style={{color: colors.primary}}> <LocalHospitalIcon style={{marginRight: 2}}/> Ver información prestador</Button>,
            metodo: (value) => redirectToPrestadores(value)
        }
    ]

    useEffect(() => {
      if (lista?.result?.data?.length > 0) {
          setOpen(true); 
          setCantidadRegistros(lista.result.cantidadRegistros);
          setData(lista.result.data);
          setIdRegimen(lista.idRegimen || 0);
          setDescripcionRegimen(lista.descripcionRegimen || '');
      }
  }, [lista]);

    const handleClose = () => {
      setOpen(false);
      setSearch('');
    };

    const redirectToPrestadores = (value) => {

        setIdPrestador(value?.codigoPrestador)
        setNombrePrestador(value?.nombre)
        navigate(`/consulta/prestadores`);
    };

    const handlerPage = (pagina, registroPorPagina) =>{
      verMas(lista.codigoProcedimiento, pagina, registroPorPagina)
    }

    // Filtra client-side la página actualmente cargada por el texto de búsqueda.
    const filteredData = useMemo(() => {
      if (!search) return data;
      const term = search.toLowerCase();
      return data.filter(row =>
        Object.values(row || {}).some(v =>
          v != null && String(v).toLowerCase().includes(term)
        )
      );
    }, [data, search]);

  return (
    
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
  >
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', sm: '80%', md: '60%' }, 
      maxWidth: 900,
      bgcolor: 'background.paper',
      borderRadius: 5,
      boxShadow: 24,
      p: 4,
      maxHeight: '80vh', 
      overflowY: 'auto', 
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 10,
        right: 20,
        cursor: 'pointer',
        color: 'green', 
        '&:hover': {
          color: 'red',
        },
        fontWeight: 'bold',
        fontSize: '1.5rem',
      }}
      onClick={handleClose}
    >
      X
    </Box>

    <Typography id="modal-title" variant="h6" component="h2">
      Prestadores de servicios PDSS
    </Typography>

    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        mt: 2,
        mb: 1,
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar prestador..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ flex: 1, maxWidth: { md: 480 } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: colors.primary }} />
            </InputAdornment>
          )
        }}
      />
      {descripcionRegimen ? (
        <Chip
          label={`Régimen: ${descripcionRegimen}`}
          sx={{
            backgroundColor: colors.primary,
            color: 'white',
            fontWeight: 'bold',
            alignSelf: { xs: 'flex-start', md: 'center' },
          }}
        />
      ) : null}
    </Box>

    <Box sx={{ mt: 1 }}>
      <CustomTable
        columns={columnas}
        acciones={acciones}
        rows={filteredData}
        handlerPage={handlerPage}
        totalDisponibles={search ? filteredData.length : cantidadRegistros}
      />
    </Box>
  </Box>
</Modal>


  );
}

export default VerDetallesPrestadores